import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// material-ui
import Centrifuge from "centrifuge";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
} from "@material-ui/core";
import TableEmptyState from "../../common/TableEmptyState";
import {
  basketAction,
  getMarginAction,
  placeOrdersAction,
} from "../../../redux/actions/brokerAction";
import { Form } from "react-bootstrap";
import moment from "moment";
import CachedIcon from "@mui/icons-material/Cached";
import { generateUniqueId, fmtINR, calculateSLTP, calculatePrice, getLocalStorageObject, setLocalStorageObject, sessionExpireHandle } from "../../../util/helper";
import {
  getTicksData,
  getOptionInstrumentByStrike
} from "../../../redux/actions/optionChain";
import { Select, Tooltip, Modal, Button as AntdButton, Switch, Input, Radio, Button } from "antd";
import TableCom from "./table";
import PlusMinQty from "../../utilities/PlusMinQty";
import { Bolt, Zap, Info, IndianRupee, RefreshCcw } from "lucide-react";
import SLTPModalBasket from "./SLTPModalBasket";
import { useToast } from "components/common/custom-toast/Toast";

const { Option } = Select;
const config = {
  feilds: [
    { key: "transactionType", dataKey: "Side", align: "center", isString: true },
    { key: "symbol", dataKey: "Symbol", align: "center", isString: true },
    { key: "strike", dataKey: "Strike", align: "center", isString: true },
    { key: "expiry", dataKey: "Expiry", align: "center", isString: true },
    { key: "cellType", dataKey: "Type", align: "center", isString: true },
    { key: "orderType", dataKey: "Order Type", align: "center", isString: true },
    { key: "quantity", dataKey: "Quantity", align: "center", isString: true },
    { key: "ltp", dataKey: "LTP", align: "center", isString: true },
    { key: "price", dataKey: "Price", align: "center", isString: true },
    { key: "stopLossPrice", dataKey: "StopLoss", align: "center", isString: true },
    { key: "targetPrice", dataKey: "Target", align: "center", isString: true },
    { key: "margin", dataKey: "Margin", align: "right", isString: true },
    { key: "action", dataKey: "Action", align: "center", isString: true },
  ],
};

const initial = {
  BasketName: "",
  basketId: "",
  stopLossAbsolute: 0,
  takeProfitAbsolute: 0,
  trailReferenceAbsolute: 0,
  trailStepAbsolute: 0,
};

const OptionChainBasketTbl = ({
  info,
  inputValues,
  width,
  height,
  windowScreen,
  handleEditBasketOrder
}) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const qtyVal = useRef(1);

  const columns = React.useMemo(() => [
    { accessor: "drag", Header: "", align: "center", isString: true },
    { accessor: "transactionType", Header: "Side", align: "center", isString: true },
    { accessor: "product", Header: "Product", align: "center", isString: true },
    { accessor: "symbol", Header: "Symbol", align: "center", isString: true },
    { accessor: "expiry", Header: "Expiry", align: "center", isString: true },
    { accessor: "strike", Header: "Strike", align: "center", isString: true },
    { accessor: "cellType", Header: "Type", align: "center", isString: true },
    { accessor: "orderType", Header: "Order Type", align: "center", isString: true },
    { accessor: "quantity", Header: "Quantity", align: "center", isString: true },
    { accessor: "ltp", Header: "LTP", align: "right", isString: true },
    { accessor: "price", Header: "Price", align: "center", isString: true },
    { accessor: "legRiskSettings", Header: "Risk Settings", align: "center", isString: true },
    { accessor: "charges", Header: "Charges", align: "center", isString: true },
    { accessor: "margin", Header: "Margin", align: "right", isString: true },
    { accessor: "action", Header: "Action", align: "center", isString: true },
  ], []);

  const basket = useSelector((state) => state.basket.data);
  const margin = useSelector((state) => state.margin.data);
  const positions = useSelector((state) => state.orders.positions);
  const funds = useSelector((state) => state?.margin?.funds);
  const strikeData = useSelector((state) => state?.optionChaininstruments?.strikeData);
  const expiryOptions = useSelector((state) => state?.optionChaininstruments?.expiry);
  const strategygrouping = useSelector((state) => state?.instrumentConfig?.strategygrouping?.strategygrouping);
  const suscriptionStatus = useSelector((state) => state?.packages?.suscriptionStatus);
  const [sltpModalShow, setSltpModalShow] = useState(false);
  const [chargesModalOpen, setChargesModalOpen] = useState(false);
  const [selectedCharges, setSelectedCharges] = useState(null);
  const toast = useToast()

  const handleShowCharges = (charges) => {
    if (charges) {
      setSelectedCharges(charges);
      setChargesModalOpen(true);
    } else {
      toast.error("Charges details not available");
    }
  };

  const [defBasket, setdefBasket] = useState([]);
  const [isRefresh, setisRefresh] = useState(false);
  const [deftotalMargin, setdeftotalMargin] = useState(0);
  const [existbasketName, setexistbasketName] = useState([]);

  const [tickData, settickData] = useState({});
  const [multiplier, setmultiplier] = useState(() => getLocalStorageObject("basket")?.multiplier || 1);
  const [formData, setFormData] = useState(() => {
    const saved = getLocalStorageObject("basket")?.formData;
    return saved ? { ...initial, ...saved } : initial;
  });

  const [rmsData, setRmsData] = useState(null);
  // NEW: switch between creating a new strategy vs adding to an existing one
  const [addToExisting, setAddToExisting] = useState(false);

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (positions && positions.length > 0) {
      let existbasketName = [];
      for (let i = 0; i < positions.length; i++) {
        if (positions[i].basketName) {
          var index = existbasketName.findIndex(
            (item) => item.basketName === positions[i].basketName
          );
          if (index === -1) {
            existbasketName.push({
              basketId: positions[i].basketId,
              basketName: positions[i].basketName,
            });
          }
        }
      }
      setexistbasketName(existbasketName);

    }
  }, [positions]);

  useEffect(() => {
    if (basket.length > 0) {
      getMargin(basket);
    }
  }, [basket]);


  useEffect(() => {
    if (!basket || basket.length === 0 || !inputValues) return;

    let needsUpdate = false;
    const updatedBasket = basket.map(item => {
      if (item._rmsInitialized) return item;
      needsUpdate = true;

      const shouldSuppressDefault = inputValues?.applyRmsToSellOnly && item.transactionType !== "SELL";
      const basisValue = inputValues?.legRms?.basis === 0 ? 0 : 1;
      const usePnl = basisValue === 0;

      return {
        ...item,
        _rmsInitialized: true,
        sltpType: usePnl ? "PNL" : "Price",
        stopLossPrice: shouldSuppressDefault ? null : (inputValues?.legRms?.stopLossInput?.value ?? null),
        targetPrice: shouldSuppressDefault ? null : (inputValues?.legRms?.targetInput?.value ?? null),
        trailSLReference: shouldSuppressDefault ? null : (inputValues?.legRms?.trailSL?.reference ?? null),
        trailSLStep: shouldSuppressDefault ? null : (inputValues?.legRms?.trailSL?.step ?? null),
        stopLossValueType: shouldSuppressDefault ? 0 : (inputValues?.legRms?.stopLossInput?.valueType ?? 0),
        targetValueType: shouldSuppressDefault ? 0 : (inputValues?.legRms?.targetInput?.valueType ?? 0),
        trailSLValueType: shouldSuppressDefault ? 0 : (inputValues?.legRms?.trailSL?.valueType ?? 0),
        profitLockAt: shouldSuppressDefault ? null : (inputValues?.legRms?.profitLockAt ?? null),
        profitLockSl: shouldSuppressDefault ? null : (inputValues?.legRms?.profitLockSl ?? null),
        profitLockTrailReference: shouldSuppressDefault ? null : (inputValues?.legRms?.profitLockTrail?.reference ?? null),
        profitLockTrailStep: shouldSuppressDefault ? null : (inputValues?.legRms?.profitLockTrail?.step ?? null),
        profitLockTrailValueType: shouldSuppressDefault ? 2 : (inputValues?.legRms?.profitLockTrail?.valueType ?? 2),
        marketProtect: inputValues?.marketProtect ?? 0,
        marketBuffer: inputValues?.marketBuffer ?? 0,
      };
    });

    if (needsUpdate) {
      dispatch(basketAction(updatedBasket));
    }
  }, [basket, inputValues]);

  // Build defBasket from basket + margin data only (no RMS merging needed)
  useEffect(() => {
    async function getTick(instrumentToken) {
      const data = await getTicksData(instrumentToken);
      if (data && data?.sessionExpired) {
        sessionExpireHandle();
      }
      if (data) {
        settickData(data)
      }
    }

    if (basket && basket.length > 0) {
      let defJSON = [];
      var totalMargin = 0;
      var instrumentToken = [];
      for (let i = 0; i < basket.length; i++) {
        const item = {
          ...basket[i],
          margin: margin?.margins?.[i]?.margin.toFixed(2) ?? 0,
          charges: margin?.margins?.[i]?.charges ?? null,
        };
        totalMargin += margin?.margins && margin?.margins[i] ? parseFloat(margin?.margins[i].margin) : 0;
        defJSON.push(item);
        instrumentToken.push(item.instrumentToken)
      }
      getTick(instrumentToken);
      setdefBasket(defJSON);
      setdeftotalMargin(totalMargin);
    } else {
      setdefBasket([]);
      setdeftotalMargin(0);
      setmultiplier(1)
    }
  }, [margin, basket]);

  useEffect(() => {
    setRmsData({ rms: inputValues?.strategyRms })
    if (basket && basket.length > 0) {
      const value = { ...formData, BasketName: basket[0].basketName };
      setFormData(value);
      const isGrouping = getLocalStorageObject("global-bottom-other") ? getLocalStorageObject("global-bottom-other").strategygrouping : true;
      if (basket[0].basketName && isGrouping) {
        const value = { ...formData, BasketName: basket[0].basketName };
        setFormData(value);
      } else {
        const value = { ...formData, BasketName: "" };
        setFormData(value);
      }
    }
  }, [basket]);


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const current = getLocalStorageObject("basket") || {};
    setLocalStorageObject("basket", "basket", basket || [], current);
    setLocalStorageObject("basket", "multiplier", multiplier, current);
    setLocalStorageObject("basket", "formData", formData, current);
  }, [basket, multiplier, formData]);

  const handleFieldChange = (e) => {
    const value = { ...formData, [e.target.name]: e.target.value };
    setFormData(value);
  };

  const calculateCombinedPremium = () => {
    if (!defBasket || defBasket.length === 0) return 0;
    let buyPremium = 0;
    let sellPremium = 0;
    const usePerLot = !!rmsData?.rms?.perLot;
    for (let i = 0; i < defBasket.length; i++) {
      const leg = defBasket[i];
      const netQty = parseFloat(leg.netQuantity || 0);
      const qty = Math.abs(netQty || parseFloat(leg.quantity || 0) || 0);
      const lotSize = parseFloat(leg.lotSize || 1);
      const lots = lotSize > 0 ? qty / lotSize : qty;
      const ltp = Number(tickData[leg.instrumentToken]?.lp || leg.ltp || 0);
      const side = leg.transactionType
        ? String(leg.transactionType).toUpperCase()
        : (netQty < 0 ? "SELL" : netQty > 0 ? "BUY" : null);

      if (lots > 0 && side) {
        if (usePerLot) {
          if (side === "BUY") {
            buyPremium += ltp;
          } else if (side === "SELL") {
            sellPremium += ltp;
          }
        } else {
          if (side === "BUY") {
            buyPremium += ltp * lots;
          } else if (side === "SELL") {
            sellPremium += ltp * lots;
          }
        }
      }
    }
    return buyPremium - sellPremium;
  };

  const handleOrderExit = (row) => {
    const filter = defBasket?.filter((item) => item.id != row.id);
    const param = filter.map((item) => ({
      "exchange": item.exchange,
      "variety": item.variety,
      "validity": item.validity,
      "product": item.product,
      "orderType": item.orderType === "Limit at LTP" ? "MARKET" : (["MARKET", "Mkt protect", "Limit with buffer"].includes(item.orderType) ? "LIMIT" : item.orderType),
      "price": item.price,
      "triggerPrice": item.triggerPrice,
      "transactionType": item.transactionType,
      "quantity": item.quantity,
      "exchangeToken": item.exchangeToken
    }))
    dispatch(basketAction(filter));
    dispatch(getMarginAction(info?.broker?.id, { orders: param }));
  };

  const handleBasketExecuteOrder = async (e, strategygrouping) => {
    let defOrder = [];
    const fetchTokens = Array.from(new Set(defBasket.map(o => o.instrumentToken || o.exchangeToken))).filter(Boolean);
    const latestTicks = await getTicksData(fetchTokens);

    for (let i = 0; i < defBasket.length; i++) {
      const item = defBasket[i];
      const token = item.instrumentToken;
      const ltp = latestTicks[token]?.lp || tickData[token]?.lp || 0;

      let rmsObject = {};

      const slValue = item.stopLossPrice ?? null;
      const tpValue = item.targetPrice ?? null;
      const trailRef = item.trailSLReference ?? null;
      const trailStep = item.trailSLStep ?? null;
      const slType = item.stopLossValueType ?? 0;
      const tpType = item.targetValueType ?? 0;
      const trType = item.trailSLValueType ?? 0;
      const usePnl = item.sltpType === "PNL";

      if (slValue !== null || tpValue !== null || (trailRef !== null && trailStep !== null)) {
        rmsObject = {
          "basis": usePnl ? 0 : 1,
          "stopLossInput": slValue == null ? null : { "valueType": slType, "value": parseFloat(slValue) },
          "targetInput": tpValue == null ? null : { "valueType": tpType, "value": parseFloat(tpValue) },
          "trailSL": trailRef == null || trailStep == null ? null : { "valueType": trType, "reference": parseFloat(trailRef), "step": parseFloat(trailStep) },
          "profitLockAt": item.profitLockAt ?? null,
          "profitLockSl": item.profitLockSl ?? null,
          "profitLockTrail": (item.profitLockTrailReference ?? null) == null ? null : {
            "valueType": item.profitLockTrailValueType ?? 2,
            "reference": parseFloat(item.profitLockTrailReference),
            "step": parseFloat(item.profitLockTrailStep)
          },
        };
      }
      let finalOrderType = item.orderType;
      let executionPrice = item.price;
      let finalTriggerPrice = item.triggerPrice || null;
      const mProtect = item.marketProtect || 0;
      if (item.orderType === "Mkt protect" && parseFloat(mProtect) === 0) {
        finalOrderType = "MARKET"; executionPrice = null;
      } else if (item.orderType === "MARKET") {
        if (parseFloat(mProtect) === 0) { finalOrderType = "MARKET"; executionPrice = null; }
        else { finalOrderType = "LIMIT"; const calculated = calculatePrice(ltp, mProtect, item.transactionType); executionPrice = calculated.price; }
      } else if (item.orderType === "SL-M") {
        finalOrderType = "SL";
      } else if (item.orderType === "Mkt protect" || item.orderType === "Limit at LTP" || item.orderType === "Limit with buffer") {
        finalOrderType = "LIMIT";
      }
      var param = {
        "exchange": item.exchange, "variety": item.variety, "validity": item.validity || inputValues?.validity || "DAY",
        "product": item.product, "orderType": finalOrderType, "transactionType": item.transactionType,
        "quantity": item.quantity, "price": executionPrice, "triggerPrice": finalTriggerPrice,
        "exchangeToken": item.exchangeToken, "disclosedQuantity": item.disclosedQuantity, "rms": rmsObject
      }
      defOrder.push(param)
      if (!strategygrouping) {
        const orderSingle = { basketName: "", basketId: "", orders: [param], ignoreBasketMove: false };
        placeOrders(orderSingle, true);
      }
    }
    if (strategygrouping) {
      const order = {
        basketName: strategygrouping ? formData.BasketName : "",
        basketId: strategygrouping ? formData.basketId : "",
        orders: defOrder,
        ignoreBasketMove: false
      };
      if (rmsData) { order.rms = rmsData.rms; }
      placeOrders(order, true);
    }
  };

  const handleClearBasket = () => {
    dispatch(basketAction([]));
    setdeftotalMargin(0);
    const value = { ...formData, BasketName: "" };
    setFormData(value);
    setmultiplier(1);
    dispatch(getMarginAction(info?.broker?.id, { orders: [] }));
  };

  const processBasketMargin = () => { };

  const placeOrders = (order, isDelete) => {
    async function funplaceOrders(order) {
      const data = await dispatch(placeOrdersAction(order, info?.broker?.id, "basket"));
      if (data && data?.sessionExpired) { sessionExpireHandle(); }
      if (isDelete) { handleClearBasket(); setFormData(initial); }
    }
    funplaceOrders(order);
  };

  const updateFieldValue = (name, formValue, index, row) => {
    const filterIndex = defBasket?.findIndex((item) => item.id === row.id);
    var qty = name.split("_")[0];
    if (filterIndex !== -1) {
      if (qty === "quantity") { defBasket[filterIndex].quantity = row.lotSize * formValue[name]; }
      else { defBasket[filterIndex].price = parseFloat(formValue[name]); }
      dispatch(basketAction(defBasket));
    }
  };


  const handleOrderCopy = async (row) => {
    var copyRow = { ...row, id: generateUniqueId() };
    dispatch(basketAction([...basket, copyRow]));
  };

  const handleOrderexecute = async (row) => {
    if (!formData.BasketName.trim()) {
      toast.error("Please enter basket Name");
      return false;
    } else {
      const latestTicks = await getTicksData([row.instrumentToken]);
      const ltp = latestTicks[row.instrumentToken]?.lp || tickData[row.instrumentToken]?.lp || 0;
      var defOrder = [];

      let rmsObject = {};

      const slValue = row.stopLossPrice ?? null;
      const tpValue = row.targetPrice ?? null;
      const trailRef = row.trailSLReference ?? null;
      const trailStep = row.trailSLStep ?? null;
      const slType = row.stopLossValueType ?? 0;
      const tpType = row.targetValueType ?? 0;
      const trType = row.trailSLValueType ?? 0;
      const usePnl = row.sltpType === "PNL";

      if (slValue !== null || tpValue !== null || (trailRef !== null && trailStep !== null)) {
        rmsObject = {
          "basis": usePnl ? 0 : 1,
          "stopLossInput": slValue == null ? null : { "valueType": slType, "value": parseFloat(slValue) },
          "targetInput": tpValue == null ? null : { "valueType": tpType, "value": parseFloat(tpValue) },
          "trailSL": trailRef == null || trailStep == null ? null : { "valueType": trType, "reference": parseFloat(trailRef), "step": parseFloat(trailStep) },
          "profitLockAt": row.profitLockAt ?? null,
          "profitLockSl": row.profitLockSl ?? null,
          "profitLockTrail": (row.profitLockTrailReference ?? null) == null ? null : {
            "valueType": row.profitLockTrailValueType ?? 2,
            "reference": parseFloat(row.profitLockTrailReference),
            "step": parseFloat(row.profitLockTrailStep)
          },
        };
      }
      let finalOrderType = row.orderType;
      let executionPrice = row.price;
      let finalTriggerPrice = row.triggerPrice || null;
      const mProtect = row.marketProtect || 0;
      if (row.orderType === "Mkt protect" && parseFloat(mProtect) === 0) {
        finalOrderType = "MARKET"; executionPrice = null;
      } else if (row.orderType === "MARKET") {
        if (parseFloat(mProtect) === 0) { finalOrderType = "MARKET"; executionPrice = null; }
        else { finalOrderType = "LIMIT"; const calculated = calculatePrice(ltp, mProtect, row.transactionType); executionPrice = calculated.price; }
      } else if (row.orderType === "SL-M") {
        finalOrderType = "SL";
      } else if (row.orderType === "Mkt protect" || row.orderType === "Limit at LTP" || row.orderType === "Limit with buffer") {
        finalOrderType = "LIMIT";
      }
      defOrder.push({
        "exchange": row.exchange, "variety": row.variety, "validity": row.validity || inputValues?.validity || "DAY",
        "product": row.product || "MIS", "orderType": finalOrderType, "transactionType": row.transactionType,
        "quantity": row.quantity, "price": executionPrice, "triggerPrice": finalTriggerPrice,
        "exchangeToken": row.exchangeToken, "disclosedQuantity": row.disclosedQuantity, "rms": rmsObject
      });
      const order = { basketName: formData.BasketName, basketId: formData.basketId, rms: rmsData.rms, orders: defOrder };
      placeOrders(order, false);
      handleOrderExit(row);
    }
  };

  const refreshMargin = () => {
    const param = defBasket.map((item) => ({
      "exchange": item.exchange, "variety": item.variety, "validity": item.validity,
      "product": item.product || "MIS",
      "orderType": item.orderType === "Limit at LTP" ? "MARKET" : (["MARKET", "Mkt protect", "Limit with buffer"].includes(item.orderType) ? "LIMIT" : item.orderType),
      "price": item.price, "triggerPrice": item.triggerPrice, "transactionType": item.transactionType,
      "quantity": item.quantity, "exchangeToken": item.exchangeToken
    }))
    console.log(param)
    dispatch(getMarginAction(info?.broker?.id, { orders: param }));
  };

  const clickHandle = (e) => {
    if (e) {
      var filter = existbasketName.find((item) => item.basketId === e);
      const value = {
        ...formData,
        BasketName: filter ? filter.basketName : (formData.BasketName ? formData.BasketName : e),
        basketId: e,
      };
      setFormData(value);
    }
  };

  const handlessltpPrice = (data) => {
    const updatedBasket = basket.map(item => {
      if (item.id === data.id) {
        const rmsFields = [
          "sltpType", "stopLossPrice", "targetPrice",
          "stopLossValueType", "targetValueType",
          "trailSLReference", "trailSLStep", "trailSLValueType",
          "profitLockAt", "profitLockSl",
          "profitLockTrailReference", "profitLockTrailStep", "profitLockTrailValueType",
          "marketProtect", "marketBuffer"
        ];

        let update = {
          ...item,
          _rmsInitialized: true
        };

        rmsFields.forEach(field => {
          if (data.hasOwnProperty(field)) {
            update[field] = data[field];
          }
        });

        if (data.profitLockTrailRef !== undefined) update.profitLockTrailReference = data.profitLockTrailRef;
        if (data.profitLockTrailStep !== undefined) update.profitLockTrailStep = data.profitLockTrailStep;

        return update;
      }
      return item;
    });
    dispatch(basketAction(updatedBasket));
  };

  const changeBuySell = (row) => {
    let newDataArray = defBasket.map((basket) => {
      if (basket.id === row.id) { return { ...basket, transactionType: row.transactionType === "BUY" ? "SELL" : "BUY" } }
      return basket;
    });
    setdefBasket(newDataArray);
    dispatch(basketAction(newDataArray));
  }

  const handleSltpBasisChange = (row, value) => {
    let newDataArray = defBasket.map((basket) => {
      if (basket.id === row.id) { return { ...basket, sltpType: value } }
      return basket;
    });
    setdefBasket(newDataArray);
    dispatch(basketAction(newDataArray));
  }

  const strikeChange = (type, row) => {
    let filterStrike = defBasket.filter((basket) => basket.strike === row.strike && basket.cellType === row.cellType && basket.expiry === row.expiry)
    var strikes = Object.keys(strikeData);
    var getStrikeIndex = strikes.findIndex((i) => i == row.strike);
    var index = type === "plus" ? getStrikeIndex + 1 : getStrikeIndex - 1;
    if (strikes[index]) {
      let newDataArray = defBasket.map((basket) => {
        if (basket.id === row.id) {
          return {
            ...basket,
            strike: strikeData[strikes[index]].strike,
            exchange: strikeData[strikes[index]].symbolsToStrikePrice["exchange-" + row.cellType],
            exchangeToken: strikeData[strikes[index]].symbolsToStrikePrice["exchangeToken-" + row.cellType],
            instrumentToken: strikeData[strikes[index]].symbolsToStrikePrice[row.cellType]
          }
        }
        return basket;
      });
      dispatch(basketAction(newDataArray));
    }
  };

  const orderTypeClick = (row) => {
    if (inputValues.enableOrderWindow) {
      if (handleEditBasketOrder) { handleEditBasketOrder(row); }
      return;
    }
    let orderType = "Mkt protect";
    if (row.orderType === "Mkt protect") { orderType = "Limit at LTP"; }
    else if (row.orderType === "Limit at LTP") { orderType = "Limit with buffer"; }
    else if (row.orderType === "Limit with buffer") { orderType = "Mkt protect"; }
    let newDataArray = defBasket.map((basket) => {
      if (basket.id === row.id) { return { ...basket, orderType: orderType } }
      return basket;
    });
    dispatch(basketAction(newDataArray));
  }

  const handleFieldcClick = (row, val, name) => {
    let updatedArray = defBasket.map((basket) => {
      if (basket.id === row.id) {
        if (name === "quantity") {
          const units = parseFloat(val) * parseFloat(row.lotSize);
          return { ...basket, quantity: units, oldquantity: units };
        } else {
          return { ...basket, [name]: val > 0 ? parseFloat(val) : val };
        }
      }
      return basket;
    });
    if (name === "quantity") {
      updatedArray = updatedArray.map((b) => ({ ...b, oldquantity: parseFloat(b.quantity) || 0 }));
      setmultiplier(1);
      qtyVal.current = 1;
    }
    dispatch(basketAction(updatedArray));
    getMargin(updatedArray);
  }

  const cellTypeClick = (row) => {
    var cellType = row.cellType === "CE" ? "PE" : "CE";
    let filterCellType = defBasket.filter((basket) => basket.strike === row.strike && basket.cellType === cellType && basket.expiry == row.expiry)
    if (filterCellType.length > 0) { return; }
    row.cellType = cellType;
    getOptionInstrument(row, moment(row.expiry).format("YYYY-MM-DD"))
  }

  const handleExpiryChange = (row, e) => {
    var checkSameStrike = defBasket.filter(
      (i) => i.strike == row.strike && i.cellType == row.cellType && i.expiry == moment(e).format("YYYY-MM-DD")
    );
    if (checkSameStrike.length > 0) { return; }
    getOptionInstrument(row, moment(e).format("YYYY-MM-DD"))
  }

  const handleProductChange = (row, product) => {
    let newDataArray = defBasket.map((basket) => {
      if (basket.id === row.original.id) { return { ...basket, product: product } }
      return basket;
    });
    dispatch(basketAction(newDataArray));
    getMargin(newDataArray);
  }

  const getOptionInstrument = async (row, expiry) => {
    const Instrumentdata = await getOptionInstrumentByStrike(info?.instrument, row.cellType, expiry, row.strike);
    if (Instrumentdata && Instrumentdata?.sessionExpired) { sessionExpireHandle(); }
    else if (Instrumentdata) {
      let newDataArray = defBasket.map((basket) => {
        if (basket.id === row.id) {
          return {
            ...basket,
            exchange: Instrumentdata?.exchange,
            exchangeToken: Instrumentdata?.exchangeToken,
            instrumentToken: Instrumentdata?.instrumentToken,
            cellType: Instrumentdata?.instrumentType,
            expiry: expiry
          }
        }
        return basket;
      });
      dispatch(basketAction(newDataArray));
    }
  }

  const updateMultiplier = (val) => {
    setmultiplier(val);
    const newDataArray = defBasket.map((basket) => {
      const lotSize = parseFloat(basket?.lotSize) || 0;
      if (!lotSize) { return { ...basket }; }
      const baseUnits = basket?.oldquantity && parseFloat(basket.oldquantity) > 0 ? parseFloat(basket.oldquantity) : parseFloat(basket.quantity) || 0;
      const baseLots = baseUnits / lotSize;
      const newLots = baseLots * val;
      const newUnits = newLots * lotSize;
      return { ...basket, quantity: newUnits };
    });
    dispatch(basketAction(newDataArray));
    getMargin(newDataArray);
    qtyVal.current = val;
  };

  const getMargin = (newDataArray) => {
    const param = newDataArray.map((item) => ({
      "exchange": item.exchange, "variety": item.variety, "validity": item.validity,
      "product": item.product || "MIS",
      "orderType": item.orderType === "Limit at LTP" ? "MARKET" : (["MARKET", "Mkt protect", "Limit with buffer"].includes(item.orderType) ? "LIMIT" : item.orderType),
      "price": item.price, "triggerPrice": item.triggerPrice, "transactionType": item.transactionType,
      "quantity": item.quantity, "exchangeToken": item.exchangeToken
    }))
    if (param.length > 0) { dispatch(getMarginAction(info?.broker?.id, { orders: param })); }
  }

  return (
    <div className="basket-viewport" style={{ height: width > 1009 ? height - 50 : height - 90 }}>
      <div className="basket-scrollable opt-chn-tbl">
        {tickData && Object.keys(tickData).length > 0 && defBasket && defBasket.length > 0 ? (
          <TableCom
            columns={columns}
            data={defBasket}
            setData={setdefBasket}
            margin={0}
            info={info}
            tickData={tickData}
            inputValues={inputValues}
            windowScreen={windowScreen}
            handleOrderExit={handleOrderExit}
            handleOrderRefresh={refreshMargin}
            handleOrderCopy={handleOrderCopy}
            updateFieldValue={updateFieldValue}
            handleOrderexecute={handleOrderexecute}
            handlessltpPrice={handlessltpPrice}
            changeBuySell={changeBuySell}
            strikeChange={strikeChange}
            cellTypeClick={cellTypeClick}
            expiryOptions={expiryOptions}
            handleExpiryChange={handleExpiryChange}
            handleProductChange={handleProductChange}
            orderTypeClick={orderTypeClick}
            handleFieldcClick={handleFieldcClick}
            handleSltpBasisChange={handleSltpBasisChange}
            handleShowCharges={handleShowCharges}
          />
        ) : (
          <Table stickyHeader size="small" style={{ height: "100%" }}>
            <TableBody>
              <TableEmptyState colSpan={columns.length} height={height - 81} message="No items in basket" />
            </TableBody>
          </Table>
        )}
      </div>

      {height > 60 &&
        <div className="busketList_btn_container order-window-body">
          <div style={{ textAlign: "center", lineHeight: "0.8rem" }} className="py-1 d-flex align-items-center justify-content-center">
            <span style={{ fontSize: "13px" }} className="me-2">Total Margin</span>
            <b className="font-13px me-2 d-flex align-items-center">
              {margin && margin.totalMargin > 0 ? fmtINR(margin.totalMargin) : 0.0}
              <Tooltip overlayStyle={{ position: 'fixed' }} placement="top" title="Refresh">
                <AntdButton size="small" className="ms-2" icon={<RefreshCcw size={14} />} onClick={() => refreshMargin()} />
              </Tooltip>
            </b>
          </div>
          <div style={{ textAlign: "center", lineHeight: "0.8rem" }} className="py-1 d-flex align-items-center justify-content-center">
            <span style={{ fontSize: "13px" }} className=" me-2">Avl. Margin</span>
            <b className="font-13px">{(funds && funds?.marginAvailable) ? fmtINR(funds?.marginAvailable) : 0.00}</b>
          </div>
          <Tooltip overlayStyle={{ position: 'fixed' }} placement="top" title="View Charges">
            <AntdButton
              size="small"
              className="ms-2"
              icon={<IndianRupee size={14} />}
              onClick={() => {
                if (margin?.totalCharges) { handleShowCharges(margin.totalCharges); }
                else { toast.error("Total charges details not available"); }
              }}
            />
          </Tooltip>
          <div className="bas-inputs">
            <Form.Group className="form-group">
              <Form.Label>Multiplier</Form.Label>{" "}
              <Form.Label className="custom-label"> </Form.Label>
              <PlusMinQty
                qtyClick={(qty, value) => { if (parseFloat(qty) > 0) { updateMultiplier(parseFloat(qty)); } }}
                filterValue={multiplier}
                name={"multiplier"}
                min={1}
                step={1}
              />
            </Form.Group>
          </div>

          {strategygrouping && (
            <div className="busketList_btns position-relative">
              <Form.Group style={{ paddingLeft: 0 }} className="form-group position-relative">
                <div>
                  <Select
                    value={addToExisting}
                    onChange={(val) => {
                      setAddToExisting(val);
                      if (!val) {
                        setFormData((f) => ({ ...f, basketId: "", BasketName: "" }));
                      }
                    }}
                    size="small"
                    className="w-100"
                    style={{ fontSize: '10px' }}
                    options={[
                      { value: false, label: 'New strategy' },
                      { value: true, label: 'Add to strategy' }
                    ]}
                  />
                </div>

                {addToExisting ? (
                  <Select
                    showSearch
                    placeholder="Search strategy..."
                    optionFilterProp="children"
                    size="small"
                    style={{ fontSize: '10px', width: '150px' }}
                    value={formData.basketId || undefined}
                    onChange={(value) => clickHandle(value)}
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    options={existbasketName.map((b) => ({
                      value: b.basketId,
                      label: b.basketName,
                    }))}
                  />
                ) : (
                  <Input
                    style={{ width: '150px' }}
                    size="small"
                    placeholder="Enter Strategy Name"
                    name="BasketName"
                    value={formData.BasketName}
                    onChange={handleFieldChange}
                  />
                )}
              </Form.Group>
            </div>
          )}

          {strategygrouping && (
            <Bolt strokeWidth={1.5} size={20} className="cursor-pointer" onClick={() => setSltpModalShow(true)} />
          )}

          <div className="busketList_btns">
            <Button type='primary' className="font-10px me-1" onClick={(e) => handleBasketExecuteOrder(e, strategygrouping)} size="sm">
              Execute
            </Button>
            <Button type='default' className="font-10px me-1" onClick={handleClearBasket} size="sm" disabled={defBasket && defBasket.length === 0}>
              Clear
            </Button>
          </div>
        </div>
      }

      <SLTPModalBasket
        show={sltpModalShow}
        setShow={setSltpModalShow}
        defBasket={defBasket}
        tickData={tickData}
        combPrem={calculateCombinedPremium()}
        info={info}
        setRmsData={setRmsData}
        popUpData={inputValues}
      />

      <Modal title="Charges Breakdown" open={chargesModalOpen} onCancel={() => setChargesModalOpen(false)} footer={null} width={400}>
        {selectedCharges ? (
          <div className="charges-modal-content">
            <div className="d-flex justify-content-between mb-2"><span>Brokerage:</span><span>₹{selectedCharges.brokerage?.toFixed(2)}</span></div>
            <div className="d-flex justify-content-between mb-2"><span>Exchange Turnover Charge:</span><span>₹{selectedCharges.exchange_turnover_charge?.toFixed(2)}</span></div>
            <div className="d-flex justify-content-between mb-2"><span>GST:</span><span>₹{selectedCharges.gst?.total?.toFixed(2)}</span></div>
            <div className="d-flex justify-content-between mb-2"><span>SEBI Turnover Charge:</span><span>₹{selectedCharges.sebi_turnover_charge?.toFixed(2)}</span></div>
            <div className="d-flex justify-content-between mb-2"><span>Stamp Duty:</span><span>₹{selectedCharges.stamp_duty?.toFixed(2)}</span></div>
            <div className="d-flex justify-content-between mb-2"><span>Transaction Tax:</span><span>₹{selectedCharges.transaction_tax?.toFixed(2)}</span></div>
            <hr />
            <div className="d-flex justify-content-between font-weight-bold"><span>Total Charges:</span><span>₹{selectedCharges.total?.toFixed(2)}</span></div>
          </div>
        ) : (
          <p>No charges data available.</p>
        )}
      </Modal>
    </div>
  );
};

export default OptionChainBasketTbl;